/**
 * Removes <style>/<script> blocks from rich-text HTML before it is reduced to plain text.
 *
 * These elements render as nothing in the HTML views (the browser hides them), but a plain-text
 * projection reads the text of every node, so their contents — e.g. CSS rules pasted in from a
 * PDF export — would otherwise leak into the text as visible characters. Stripping happens here,
 * before plain-text extraction, rather than in the shared html-to-text helper so the change stays
 * scoped to the authoring previews that need it.
 *
 * @param {string} content
 * @returns {string}
 */
export function stripNonContentElements(content) {
    return `${content ?? ""}`.replace(/<(style|script)\b[^>]*>[\s\S]*?<\/\1>/gi, "")
}
